@use "@fukuri-admins/ui/layout" as *;

.table {
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;

  // 最終行の td は外枠の下辺 border と重なるため border-bottom を消す
  tbody tr:last-child td {
    border-bottom: none;
  }
}

// scrollable=true 時に横スクロールを有効化する
// .table の overflow: hidden を .table.scrollable で上書き（複合セレクタで specificity を上げて確実に上書き）
// display: block に切り替えて flex による align-items: stretch の影響を回避し、内部 <table> がコンテナ幅を超えてオーバーフローできるようにする
.table.scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  display: block;

  // display: block により内部 <table> がコンテンツ幅まで縮むのを防ぐため、親幅まで広げる
  // 親より広い場合は <table> 本来の挙動でオーバーフローし、横スクロールが発生する
  > table {
    min-width: 100%;
  }
}

// fixedHeader=true 時に縦スクロールとヘッダー固定を有効化する
// scrollable と組み合わせると overflow-y: hidden を auto で上書きし、縦横両方スクロール可能になる
.table.fixedHeader {
  overflow-y: auto;
  display: block;

  > table {
    min-width: 100%;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}

// フロア値: 分割画面等でビューポートが極端に低い場合でもヘッダー+数行分は表示する最低保証高さ
$tableFillHeightMinHeight: 200px;

// fillHeight=true 時、テーブル自身の高さをビューポートの残り高さに合わせて可変にする
// ヘッダー固定・内部スクロールは .fixedHeader を流用する（Table コンポーネント側で同時に付与）ため、
// このブロックは max-height の指定のみ担う。max-height は上限であって height ではないため、
// 行数が少ない場合はコンテンツの高さに収まり、空白（dead space）は生まれない
// --table-fill-height-offset: ページヘッダー・ページャー分の概算値（px）。ページ側のクロム量に
// 応じて祖先要素で上書きする
// max() で $tableFillHeightMinHeight を下限に固定し、オフセットがビューポートを上回っても
// テーブルが 0 近くまで潰れないようにする
.table.fillHeight {
  max-height: max(calc(100dvh - var(--table-fill-height-offset, 240px)), $tableFillHeightMinHeight);
}

.tableFixed {
  table-layout: fixed;
  width: 100%;
}

.headRow {
  th {
    @include typography('Jp/14_W3');
    color: text('Low');
    background-color: background('Senary');
  }
}
